import React, { useState } from 'react';
import EmployeeLayout from './EmployeeLayout';

const DailyReport = () => {
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    callsMade: '',
    visitsDone: '',
    leadsConverted: '',
    notes: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Daily report submitted successfully!');
    setFormData({
      date: new Date().toISOString().split('T')[0],
      callsMade: '',
      visitsDone: '',
      leadsConverted: '',
      notes: '',
    });
  };

  return (
    <EmployeeLayout>
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white">Daily Report</h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Submit your daily field metrics and work report</p>
      </div>

      <div className="max-w-2xl">
        <div className="bg-white dark:bg-slate-900/50 rounded-2xl shadow-sm dark:shadow-xl border border-slate-200 dark:border-slate-800 p-6 sm:p-8 transition-colors">
          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Date */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">
                Date *
              </label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
                required
              />
            </div>

            {/* Calls Made */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">
                Calls Made *
              </label>
              <input
                type="number"
                name="callsMade"
                value={formData.callsMade}
                onChange={handleChange}
                placeholder="Number of client calls made"
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
                required
              />
            </div>

            {/* Visits Done */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">
                Site Visits Done *
              </label>
              <input
                type="number"
                name="visitsDone"
                value={formData.visitsDone}
                onChange={handleChange}
                placeholder="Number of physical site visits"
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
                required
              />
            </div>

            {/* Leads Converted */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">
                Leads Converted
              </label>
              <input
                type="number"
                name="leadsConverted"
                value={formData.leadsConverted}
                onChange={handleChange}
                placeholder="Number of deals finalized"
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
              />
            </div>

            {/* Notes */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">
                Notes / Key Learnings
              </label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                rows="4"
                placeholder="Write your highlights, challenges or daily feedback here..."
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full px-6 py-3 bg-[#10B981] hover:bg-emerald-600 text-white font-bold rounded-xl shadow-lg shadow-emerald-500/20 transition-all text-sm"
            >
              Submit Report
            </button>
          </form>
        </div>
      </div>
    </EmployeeLayout>
  );
};

export default DailyReport;